import {Component, EventEmitter, Input, OnInit, Output, OnChanges, SimpleChanges} from '@angular/core';
import {CubicleLayout} from '../../../shared/bsl-reference/cubicle-layout-model';
import {OfferDataManagementHelper} from '../../../shared/util/offer-data-management-helper';
import layoutJson from '../../../../../assets/layout.json';

@Component({
  standalone: false,
  selector: 'app-offer-data-management-offer-layout',
  templateUrl: './odm-offer-layout.component.html',
  styleUrls: ['./odm-offer-layout.component.less']
})
export class OdmOfferLayoutComponent implements OnInit, OnChanges {

  @Input() layoutList: CubicleLayout[];
  @Input() loading: boolean;
  @Output() onClickAddButton = new EventEmitter<CubicleLayout[]>();
  @Output() onClickCancelButton = new EventEmitter<string>();

  hasSelectedLayout: boolean;
  selectedLayout: CubicleLayout;
  numberOfLayout: number;
  currentLayout: number;
  isSettingNumberOfLayout = true;
  listOfSelectedLayouts: CubicleLayout[];
  allLayout: Set<CubicleLayout> = new Set<CubicleLayout>();
  searchTerm: string = '';
  paginatedFilteredLayouts: CubicleLayout[];
  filteredLayouts: CubicleLayout[];
  allLayoutCheck = false;
  currentPage = 1;
  pageTotal;
  perPage = 12;
  OfferDataManagementHelper = OfferDataManagementHelper;

  constructor() {
  }

  // Populate filteredLayout from input parameters and set it as a default value
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.layoutList || changes.perPage) {
      this.currentPage = 1;
      this.filteredLayouts = this.layoutList ? Array.from(this.layoutList) : [];
      this.setPaginatedResult(this.filteredLayouts, 1, this.perPage);
    }
  }

  ngOnInit() {
    this.initParameters();
  }

  nextButton() {
    if (this.isSettingNumberOfLayout) {
      this.isSettingNumberOfLayout = false;
    } else {
      this.listOfSelectedLayouts.push(this.selectedLayout);
      this.hasSelectedLayout = false;
      this.currentLayout = this.currentLayout + 1;
    }
  }
  addButton() {
    this.listOfSelectedLayouts.push(this.selectedLayout);
    this.onClickAddButton.emit(this.listOfSelectedLayouts);
    this.initParameters();
  }

  cancelButton() {
    this.initParameters();
    this.onClickCancelButton.emit('skip');
  }

  getLayoutImagePath(layoutFileName: string): string {
    let pathLayout: string;
    pathLayout = './assets/layout/' + layoutFileName;
    return pathLayout;
  }

  setLayoutValue(layout: CubicleLayout) {
    this.hasSelectedLayout = true;
    this.selectedLayout = layout;
  }

  isSelectedImage(layout): boolean {
    return this.hasSelectedLayout && layout === this.selectedLayout;
  }

  /**
   * Function to check the coherency of the number of Layout field
   */
  onChangeLayoutNumber() {
    if (!this.isValidNumber()){
      this.numberOfLayout = 1;
    }
    if (this.numberOfLayout < 1) {
      this.numberOfLayout = 1;
    } else if (this.numberOfLayout > 10) {
      this.numberOfLayout = 10;
    }
  }

  /**
   * When user set all Layout or not
   */
  onChangeAllLayout() {
    this.allLayoutCheck = !this.allLayoutCheck;
    this.currentPage = 1;
    this.getLayoutList(1, this.perPage);
  }

  isValidNumber(){
    if(!this.numberOfLayout){
      return false;
    }
    const regex = new RegExp('^[0-9]*$');
    return regex.test(this.numberOfLayout.toString());
  }


  pageChange(event: any) {
    this.currentPage = event.detail.value;
    this.getLayoutList(event.detail.value, event.detail.perPage);
  }

  /**
   * Function to get Layout list depending upon allLayoutCheck
   */
  getLayoutList(page: number, perPage: number): void {
    if (this.allLayoutCheck) {
      if (this.searchTerm === "") {
        this.filteredLayouts = Array.from(this.allLayout); // Reset to allSLD
      } else {
        this.filteredLayouts = Array.from(this.allLayout).filter((layout: CubicleLayout) =>
          layout.pictureFileName.toLowerCase().includes(this.searchTerm.toLowerCase())
        );
      }
    } else {
      if (this.searchTerm === "") {
        this.filteredLayouts = this.layoutList;
      } else {
        this.filteredLayouts = this.layoutList.filter(sld => sld.pictureFileName.toLowerCase().includes(this.searchTerm.toLowerCase()));
      }
    }
    this.setPaginatedResult(this.filteredLayouts, page, perPage);
  }

  setPaginatedResult(filteredSlds: CubicleLayout[], page: number, perPage: number): void {
    this.pageTotal = Math.ceil(filteredSlds.length / perPage);
    const fromIndex = (page - 1) * perPage;
    const toIndex = Math.min(fromIndex + perPage, filteredSlds.length);
    this.paginatedFilteredLayouts = this.filteredLayouts.slice(fromIndex, toIndex);
  }

  /**
   * Reset the component to initial state
   */
  private initParameters() {
    this.isSettingNumberOfLayout = true;
    this.currentPage = 1;
    this.numberOfLayout = 1;
    this.currentLayout = 1;
    this.hasSelectedLayout = false;
    this.listOfSelectedLayouts = [];
    this.initializeAllLayout();
    this.allLayoutCheck = false;
    this.searchTerm = "";
  }

  //  Initialize allLayout list from layoutJson
  private initializeAllLayout() {
    if (!this.allLayout || this.allLayout.size === 0) {
      this.allLayout = new Set<CubicleLayout>();
      for (const item of layoutJson.allLayoutNames) {
        this.allLayout.add(new CubicleLayout(item));
      }
    }
  }

  onSearchInput(event: Event) {
    const input = event.target as HTMLInputElement;
    this.searchTerm = input.value.trim();
    this.currentPage = 1;
    this.getLayoutList(1, this.perPage);
  }

}
